import { ApiError } from './client'

/**
 * R3-16 — pagina pubblica di riprogrammazione dopo un no-show (`/r/:token`, flag `appuntamenti.riprogrammazione`).
 * Stesse regole del link al cliente (C-09): il token e la sessione viaggiano negli header, mai nell'URL delle API.
 */
export interface RescheduleSlot {
  index: number
  start: string
  end: string
}

const BASE = '/api/public/appointment-reschedule'

async function call<T>(token: string, session: string | null, path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers)
  headers.set('X-Customer-Link', token)
  if (session) headers.set('X-Customer-Link-Session', session)
  if (init.body) headers.set('Content-Type', 'application/json')
  const res = await fetch(`${BASE}${path}`, { ...init, headers, credentials: 'omit', cache: 'no-store' })
  if (!res.ok) {
    const body = await res.json().catch(() => ({})) as { message?: string; reason?: string }
    throw new ApiError(body.message ?? 'Errore imprevisto. Riprova.', body.reason, body, res.status)
  }
  return res.json() as Promise<T>
}

export const publicRescheduleApi = {
  open: (token: string) => call<{ emailHint: string | null; expiresAt: string }>(token, null, '/open', { method: 'POST' }),
  sendOtp: (token: string) => call<{ sent: boolean }>(token, null, '/otp', { method: 'POST' }),
  verifyOtp: (token: string, code: string) =>
    call<{ session: string }>(token, null, '/otp/verify', { method: 'POST', body: JSON.stringify({ code }) }),
  slots: (token: string, session: string) => call<{ slots: RescheduleSlot[] }>(token, session, '/slots'),
  choose: (token: string, session: string, index: number) =>
    call<{ chosen: boolean; start: string }>(token, session, '/choose', { method: 'POST', body: JSON.stringify({ index }) }),
}
